export const GET_SMC_CARS_REQUEST = 'GET_SMC_CARS_REQUEST' as const;
export const GET_SMC_CARS_SUCCESS = 'GET_SMC_CARS_SUCCESS' as const;
export const GET_SMC_CARS_ERROR = 'GET_SMC_CARS_ERROR' as const;

export const POST_ADD_SMC_CARS_REQUEST = 'POST_ADD_SMC_CARS_REQUEST' as const;
export const POST_ADD_SMC_CARS_SUCCESS = 'POST_ADD_SMC_CARS_SUCCESS' as const;
export const POST_ADD_SMC_CARS_ERROR = 'POST_ADD_SMC_CARS_ERROR' as const;

export const DELETE_SMC_CARS_REQUEST = 'DELETE_SMC_CARS_REQUEST' as const;
export const DELETE_SMC_CARS_SUCCESS = 'DELETE_SMC_CARS_SUCCESS' as const;
export const DELETE_SMC_CARS_ERROR = 'DELETE_SMC_CARS_ERROR' as const;

export const CLEAR_ERROR = 'CLEAR_ERROR' as const;
